/**
 * Created by jiayanfeng on 2017/9/20.
 * 应用管理的Reducer
 */
import {combineReducers} from "redux";
import {
	Select_Search_Column_Change, Space_Apps_Table_Data_Fetch,
	Text_Search_Column_Change
} from "./SpaceAppsManagementConstants";

function runningNum(state = 0, action) {
	switch (action.type)
	{
		case Space_Apps_Table_Data_Fetch:
			return parseInt(action.data.runningNum);
		default:
			return state;
	}
}

function stoppedNum(state = 0, action) {
	switch (action.type)
	{
		case Space_Apps_Table_Data_Fetch:
			return parseInt(action.data.stoppedNum);
		default:
			return state;
	}
}

function crashedNum(state = 0, action) {
	switch (action.type)
	{
		case Space_Apps_Table_Data_Fetch:
			return parseInt(action.data.crashedNum);
		default:
			return state;
	}
}

function deployedAppSummaries(state = [], action) {
	switch (action.type)
	{
		case Space_Apps_Table_Data_Fetch: {
			return action.data.deployedAppSummaries;
		}
		default:
			return state;
	}
}


function filterColumn(state={
  name:"",
  state:[]
},action){
	switch (action.type)
	{
		case Text_Search_Column_Change:
		{
      return {
        ...state,
        name:action.data
      }
		}
		case Select_Search_Column_Change:
		{
			return {
        ...state,
        state:action.data
      };
		}
		default:
			return state;
	}
}



const SpaceAppManagementPageReducer = combineReducers({runningNum,stoppedNum,
	crashedNum,deployedAppSummaries,filterColumn,
});

export default  SpaceAppManagementPageReducer;
